import { render, staticRenderFns } from "./PreviewCarousel.vue?vue&type=template&id=5dca1263&scoped=true"
import script from "./PreviewCarousel.vue?vue&type=script&lang=js"
export * from "./PreviewCarousel.vue?vue&type=script&lang=js"
import style0 from "./PreviewCarousel.vue?vue&type=style&index=0&id=5dca1263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca1263",
  null
  
)

export default component.exports